/**
 * Runtime environment configuration loader
 * This allows the app to be built once and configured for different environments at runtime
 * 
 * Configuration Priority:
 * 1. process.env.REACT_APP_ENV (build-time env var) - Highest priority (for development)
 * 2. window.__APP_ENV__ or window.__APP_BASE_URL__ (runtime config from config.js) - Fallback (for production)
 */

interface EnvConfig {
  hotelxNodeUrl: string
  hotelxSocketUrl: string
  wsNodeUrl: string
  hotelXRefreshUrl: string
  paymentUrl: string
  reportUrl: string
  googleAPIKey: string
}

// Global variables that will be set by config.js loaded from public folder
declare global {
  interface Window {
    __APP_ENV__?: string
    __APP_BASE_URL__?: string
  }
}

// Environment configurations map
const environmentConfigs: Record<string, EnvConfig> = {
  local: {
    hotelxNodeUrl: 'http://localhost:8000/hotelx',
    hotelxSocketUrl: 'http://localhost:8000',
    wsNodeUrl: 'ws://localhost:8000/hotelx',
    hotelXRefreshUrl: 'http://localhost:8000/refresh_token_hotel',
    paymentUrl: 'http://localhost:3000',
    reportUrl: 'http://localhost:61094',
    googleAPIKey: 'AIzaSyDYu0jmtUpyzSOFRQ9R5xW_2g_djZtUh_E',
  },
  dev: {
    hotelxNodeUrl: 'https://hotelx-dev-api.ifca.io/hotelx',
    hotelxSocketUrl: 'https://hotelx-dev-api.ifca.io',
    wsNodeUrl: 'wss://hotelx-dev-api.ifca.io/hotelx',
    hotelXRefreshUrl: 'https://hotelx-dev-api.ifca.io/refresh_token_hotel',
    paymentUrl: 'https://hotelx-dev.ifca.io',
    reportUrl: 'https://hotelxdevreporting.ifca.asia/',
    googleAPIKey: 'AIzaSyDYu0jmtUpyzSOFRQ9R5xW_2g_djZtUh_E',
  },
  uat: {
    hotelxNodeUrl: 'https://hotelx-uat-api.ifca.io/hotelx',
    hotelxSocketUrl: 'https://hotelx-uat-api.ifca.io',
    wsNodeUrl: 'wss://hotelx-uat-api.ifca.io/hotelx',
    hotelXRefreshUrl: 'https://hotelx-uat-api.ifca.io/refresh_token_hotel',
    paymentUrl: 'https://hotelx-uat.ifca.io',
    reportUrl: 'https://hotelxuatreporting.ifca.asia/',
    googleAPIKey: 'AIzaSyDYu0jmtUpyzSOFRQ9R5xW_2g_djZtUh_E',
  },
  prod: {
    hotelxNodeUrl: 'https://hotelxapi.hotelx.asia/hotelx',
    hotelxSocketUrl: 'https://hotelxapi.hotelx.asia',
    wsNodeUrl: 'wss://hotelxapi.hotelx.asia/hotelx',
    hotelXRefreshUrl: 'https://hotelxapi.hotelx.asia/refresh_token_hotel',
    paymentUrl: 'https://hms.hotelx.asia',
    reportUrl: 'https://hotelxreporting.hotelx.asia/',
    googleAPIKey: 'AIzaSyDYu0jmtUpyzSOFRQ9R5xW_2g_djZtUh_E',
  },
  'hms1-prod': {
    hotelxNodeUrl: 'https://hotelx1api.hotelx.asia/hotelx',
    hotelxSocketUrl: 'https://hotelx1api.hotelx.asia',
    wsNodeUrl: 'wss://hotelx1api.hotelx.asia/hotelx',
    hotelXRefreshUrl: 'https://hotelx1api.hotelx.asia/refresh_token_hotel',
    paymentUrl: 'https://hms1.hotelx.asia',
    reportUrl: 'https://hotelxreporting1.hotelx.asia/',
    googleAPIKey: 'AIzaSyDYu0jmtUpyzSOFRQ9R5xW_2g_djZtUh_E',
  },
  'hms2-prod': {
    hotelxNodeUrl: 'https://hotelx2api.hotelx.asia/hotelx',
    hotelxSocketUrl: 'https://hotelx2api.hotelx.asia',
    wsNodeUrl: 'wss://hotelx2api.hotelx.asia/hotelx',
    hotelXRefreshUrl: 'https://hotelx2api.hotelx.asia/refresh_token_hotel',
    paymentUrl: 'https://hms2.hotelx.asia',
    reportUrl: 'https://hotelxreporting1.hotelx.asia/',
    googleAPIKey: 'AIzaSyDYu0jmtUpyzSOFRQ9R5xW_2g_djZtUh_E',
  },
  'hms3-prod': {
    hotelxNodeUrl: 'https://hotelx3api.hotelx.asia/hotelx',
    hotelxSocketUrl: 'https://hotelx3api.hotelx.asia',
    wsNodeUrl: 'wss://hotelx3api.hotelx.asia/hotelx',
    hotelXRefreshUrl: 'https://hotelx3api.hotelx.asia/refresh_token_hotel',
    paymentUrl: 'https://hms3.hotelx.asia',
    reportUrl: 'https://hotelxreporting2.hotelx.asia/',
    googleAPIKey: 'AIzaSyDYu0jmtUpyzSOFRQ9R5xW_2g_djZtUh_E',
  },
  'hms4-prod': {
    hotelxNodeUrl: 'https://hotelx4api.hotelx.asia/hotelx',
    hotelxSocketUrl: 'https://hotelx4api.hotelx.asia',
    wsNodeUrl: 'wss://hotelx4api.hotelx.asia/hotelx',
    hotelXRefreshUrl: 'https://hotelx4api.hotelx.asia/refresh_token_hotel',
    paymentUrl: 'https://hms4.hotelx.asia',
    reportUrl: 'https://hotelxreporting2.hotelx.asia/',
    googleAPIKey: 'AIzaSyDYu0jmtUpyzSOFRQ9R5xW_2g_djZtUh_E',
  },
  promenade: {
    hotelxNodeUrl: 'https://hotelxapi-promenade.hotelx.asia/hotelx',
    hotelxSocketUrl: 'https://hotelxapi-promenade.hotelx.asia',
    wsNodeUrl: 'wss://hotelxapi-promenade.hotelx.asia',
    hotelXRefreshUrl: 'https://hotelxapi-promenade.hotelx.asia/refresh_token_hotel',
    paymentUrl: 'https://promenade.hotelx.asia',
    reportUrl: 'https://hotelxreporting-promenade.hotelx.asia/',
    googleAPIKey: 'AIzaSyDYu0jmtUpyzSOFRQ9R5xW_2g_djZtUh_E',
  },
  'promenade-uat': {
    hotelxNodeUrl: 'https://hotelxapi-promenade-uat.hotelx.asia/hotelx',
    hotelxSocketUrl: 'https://hotelxapi-promenade-uat.hotelx.asia',
    wsNodeUrl: 'wss://hotelxapi-promenade-uat.hotelx.asia',
    hotelXRefreshUrl: 'https://hotelxapi-promenade-uat.hotelx.asia/refresh_token_hotel',
    paymentUrl: 'https://promenade-uat.hotelx.asia',
    reportUrl: 'https://hotelxreporting-promenade-uat.hotelx.asia/',
    googleAPIKey: 'AIzaSyDYu0jmtUpyzSOFRQ9R5xW_2g_djZtUh_E',
  },
  indo: {
    hotelxNodeUrl: 'https://indo-api.hotelx.asia/hotelx',
    hotelxSocketUrl: 'https://indo-api.hotelx.asia',
    wsNodeUrl: 'wss://indo-api.hotelx.asia/hotelx',
    hotelXRefreshUrl: 'https://indo-api.hotelx.asia/refresh_token_hotel',
    paymentUrl: '',
    reportUrl: 'https://indo-reporting.hotelx.asia/',
    googleAPIKey: 'AIzaSyDYu0jmtUpyzSOFRQ9R5xW_2g_djZtUh_E',
  },
  imperial: {
    hotelxNodeUrl: 'https://hotelxapi-imperial.hotelx.asia/hotelx',
    hotelxSocketUrl: 'https://hotelxapi-imperial.hotelx.asia',
    wsNodeUrl: 'wss://hotelxapi-imperial.hotelx.asia/hotelx',
    hotelXRefreshUrl: 'https://hotelxapi-imperial.hotelx.asia/refresh_token_hotel',
    paymentUrl: 'https://imperial.hotelx.asia',
    reportUrl: 'https://hotelxreporting-imperial.hotelx.asia/',
    googleAPIKey: 'AIzaSyDYu0jmtUpyzSOFRQ9R5xW_2g_djZtUh_E',
  },
  swan: {
    hotelxNodeUrl: 'https://hotelxswanapi.hotelx.asia/hotelx',
    hotelxSocketUrl: 'https://hotelxswanapi.hotelx.asia',
    wsNodeUrl: 'wss://hotelxswanapi.hotelx.asia/hotelx',
    hotelXRefreshUrl: 'https://hotelxswanapi.hotelx.asia/refresh_token_hotel',
    paymentUrl: 'https://swan.hotelx.asia',
    reportUrl: 'https://swan-hotelxreporting.hotelx.asia/',
    googleAPIKey: 'AIzaSyDYu0jmtUpyzSOFRQ9R5xW_2g_djZtUh_E',
  },
  'swan-uat': {
    hotelxNodeUrl: 'https://hotelxswanapi-uat.hotelx.asia/hotelx',
    hotelxSocketUrl: 'https://hotelxswanapi-uat.hotelx.asia',
    wsNodeUrl: 'wss://hotelxswanapi-uat.hotelx.asia/hotelx',
    hotelXRefreshUrl: 'https://hotelxswanapi-uat.hotelx.asia/refresh_token_hotel',
    paymentUrl: 'https://swan-uat.hotelx.asia',
    reportUrl: 'https://hotelxuatreporting.ifca.asia/',
    googleAPIKey: 'AIzaSyDYu0jmtUpyzSOFRQ9R5xW_2g_djZtUh_E',
  },
  edition: {
    hotelxNodeUrl: 'https://edition-api.hotelx.asia/hotelx',
    hotelxSocketUrl: 'https://edition-api.hotelx.asia',
    wsNodeUrl: 'wss://edition-api.hotelx.asia/hotelx',
    hotelXRefreshUrl: 'https://edition-api.hotelx.asia/refresh_token_hotel',
    paymentUrl: 'https://edition.hotelx.asia',
    reportUrl: 'https://edition-reporting.hotelx.asia/',
    googleAPIKey: 'AIzaSyDYu0jmtUpyzSOFRQ9R5xW_2g_djZtUh_E',
  },
  'edu-prod': {
    hotelxNodeUrl: 'https://hotelxapi-edu.hotelx.asia/hotelx',
    hotelxSocketUrl: 'https://hotelxapi-edu.hotelx.asia',
    wsNodeUrl: 'wss://hotelxapi-edu.hotelx.asia/hotelx',
    hotelXRefreshUrl: 'https://hotelxapi-edu.hotelx.asia/refresh_token_hotel',
    paymentUrl: 'https://edu.hotelx.asia',
    reportUrl: 'https://hotelxreporting-edu.hotelx.asia/',
    googleAPIKey: 'AIzaSyDYu0jmtUpyzSOFRQ9R5xW_2g_djZtUh_E',
  }
}

/**
 * Get the base URL from a full URL
 */
function getBaseUrl(url: string): string {
  try {
    const urlObj = new URL(url)
    return urlObj.origin
  } catch {
    return url
  }
}

/**
 * Generate WebSocket URL from base URL
 */
function getWebSocketUrl(baseUrl: string): string {
  if (baseUrl.startsWith('https://')) {
    return baseUrl.replace('https://', 'wss://')
  } else if (baseUrl.startsWith('http://') || baseUrl.includes('localhost')) {
    return baseUrl.replace('http://', 'ws://')
  }
  return `wss://${baseUrl}`
}

/**
 * Build configuration from a custom base URL
 */
function buildConfigFromBaseUrl(baseUrl: string): EnvConfig {
  const base = getBaseUrl(baseUrl)
  const wsBase = getWebSocketUrl(base)
  
  return {
    hotelxNodeUrl: `${base}/hotelx`,
    hotelxSocketUrl: base,
    wsNodeUrl: `${wsBase}/hotelx`,
    hotelXRefreshUrl: `${base}/refresh_token_hotel`,
    paymentUrl: base.replace('/hotelx', '').replace('api.', '').replace('hotelx', 'hms'),
    reportUrl: base.replace('api.', 'reporting.').replace('/hotelx', '/'),
    googleAPIKey: 'AIzaSyDYu0jmtUpyzSOFRQ9R5xW_2g_djZtUh_E',
  }
}

/**
 * Get the current environment name
 * Priority: process.env.REACT_APP_ENV > window.__APP_ENV__ > default ('prod')
 */
export function getCurrentEnv(): string {
  // Priority 1: Build-time environment variable (highest priority - for development)
  if (process.env.REACT_APP_ENV) {
    return process.env.REACT_APP_ENV
  }

  // Priority 2: Runtime configuration from config.js (fallback - for uat)
  if (typeof window !== 'undefined' && window.__APP_ENV__) {
    return window.__APP_ENV__
  }

  // Default: uat
  return 'uat'
}

/**
 * Check if current environment is production or UAT
 */
export function isProdOrUat(): boolean {
  const env = getCurrentEnv()
  return env === 'prod' || env === 'uat'
}

/**
 * Get the runtime environment configuration
 * Priority: process.env.REACT_APP_ENV > window.__APP_ENV__ or window.__APP_BASE_URL__ > default (prod)
 */
export function getEnvConfig(): EnvConfig {
  // Priority 1: Build-time environment variable (highest priority - for development)
  const buildTimeEnv = process.env.REACT_APP_ENV
  if (buildTimeEnv) {
    const envConfig = environmentConfigs[buildTimeEnv]
    if (envConfig) {
      return envConfig
    }
  }

  // Priority 2: Runtime configuration from config.js (fallback - for uat)
  if (typeof window !== 'undefined') {
    // Check for custom base URL first
    if (window.__APP_BASE_URL__) {
      return buildConfigFromBaseUrl(window.__APP_BASE_URL__)
    }
    
    // Check for environment name
    if (window.__APP_ENV__) {
      const envConfig = environmentConfigs[window.__APP_ENV__]
      if (envConfig) {
        return envConfig
      }
    }
  }

  // Default: uat configuration
  return environmentConfigs.uat || environmentConfigs.local
}
